require('../../modules/es.array.includes');

var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'includes');